import { createBasicSelector } from 'util/redux'
import { selectCurrentTicketId } from 'ducks/tickets/selectors/selectCurrentTicketId'

export const selectIsComposingNewTicket = createBasicSelector(
  selectCurrentTicketId,
  ticketId => ticketId === 'new'
)
